<template>
  <section class="search-section py-5 container">
    <div class="row">
      <div class="col-12">
        <div class="text-center mb-4">
          <h1 class="fw-light mb-3">Recherche de problèmes</h1>
          <p class="lead text-muted mb-4">Sélectionnez les caractéristiques. Explorer selon les typologies.</p>
          <button 
            :class="['btn', 'btn-outline-success', 'btn-lg', 'filter-toggle-btn', { 'heartbeat-active': showHeartbeat }]" 
            type="button"
            data-bs-toggle="collapse" 
            data-bs-target="#filterCollapse" 
            :aria-expanded="isExpanded.toString()" 
            aria-controls="filterCollapse"
            @click="toggleExpanded">
            <span>Caractéristiques</span>
            <i :class="isExpanded ? 'bi bi-chevron-up ms-2' : 'bi bi-chevron-down ms-2'" aria-hidden="true"></i>
          </button>
        </div>

        <div class="collapse" id="filterCollapse">
          <div class="filter-container">
            <!-- Niveau -->
            <div class="filter-card filter-card-warning">
              <h3 class="filter-title">
                <i class="bi bi-mortarboard me-2"></i>Niveau
              </h3>
              <div class="filter-options">
                <label class="filter-option" :class="{ active: levels.includes('CP') }">
                  <input type="checkbox" id="cp" value="CP" v-model="levels" class="sr-only">
                  <span class="filter-label">CP</span>
                  <b-badge pill class="filter-badge" v-if="facets.level.CP">{{facets.level.CP}}</b-badge>
                    </label>
                <label class="filter-option" :class="{ active: levels.includes('CE1') }">
                  <input type="checkbox" id="ce1" value="CE1" v-model="levels" class="sr-only">
                  <span class="filter-label">CE1</span>
                  <b-badge pill class="filter-badge" v-if="facets.level.CE1">{{facets.level.CE1}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: levels.includes('CE2') }">
                  <input type="checkbox" id="ce2" value="CE2" v-model="levels" class="sr-only">
                  <span class="filter-label">CE2</span>
                  <b-badge pill class="filter-badge" v-if="facets.level.CE2">{{facets.level.CE2}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: levels.includes('CM1') }">
                  <input type="checkbox" id="cm1" value="CM1" v-model="levels" class="sr-only">
                  <span class="filter-label">CM1</span>
                  <b-badge pill class="filter-badge" v-if="facets.level.CM1">{{facets.level.CM1}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: levels.includes('CM2') }">
                  <input type="checkbox" id="cm2" value="CM2" v-model="levels" class="sr-only">
                  <span class="filter-label">CM2</span>
                  <b-badge pill class="filter-badge" v-if="facets.level.CM2">{{facets.level.CM2}}</b-badge>
                  </label>
              </div>
            </div>

            <!-- Catégorie -->
            <div class="filter-card filter-card-info">
              <h3 class="filter-title">
                <i class="bi bi-tags me-2"></i>Catégorie
              </h3>
              <div class="filter-options">
                <label class="filter-option" :class="{ active: categories.includes('ADD') }">
                  <input type="checkbox" id="add" value="ADD" v-model="categories" class="sr-only">
                  <span class="filter-label">Additif (+ et -)</span>
                  <b-badge pill class="filter-badge" v-if="facets.category.ADD">{{facets.category.ADD}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: categories.includes('MUL') }">
                  <input type="checkbox" id="mul" value="MUL" v-model="categories" class="sr-only">
                  <span class="filter-label">Multiplicatif</span>
                  <b-badge pill class="filter-badge" v-if="facets.category.MUL">{{facets.category.MUL}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: categories.includes('DIV') }">
                  <input type="checkbox" id="div" value="DIV" v-model="categories" class="sr-only">
                  <span class="filter-label">Division/partage</span>
                  <b-badge pill class="filter-badge" v-if="facets.category.DIV">{{facets.category.DIV}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: categories.includes('PROP') }">
                  <input type="checkbox" id="prop" value="PROP" v-model="categories" class="sr-only">
                  <span class="filter-label">Proportionnalité</span>
                  <b-badge pill class="filter-badge" v-if="facets.category.PROP">{{facets.category.PROP}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: categories.includes('NUM') }">
                  <input type="checkbox" id="num" value="NUM" v-model="categories" class="sr-only">
                  <span class="filter-label">Autre</span>
                  <b-badge pill class="filter-badge" v-if="facets.category.NUM">{{facets.category.NUM}}</b-badge>
                  </label>
              </div>

              <!-- Typologies Additif - Sous-menu -->
              <div v-show="categories.includes('ADD') && categories.length == 1" class="filter-submenu">
                <h4 class="filter-subtitle">
                  <i class="bi bi-plus-circle me-2"></i>Typologie Additif
                </h4>
                <div class="filter-options">
                  <label class="filter-option filter-option-submenu" :class="{ active: typoAdd.includes('compos') }">
                    <input type="checkbox" id="compos" value="compos" v-model="typoAdd" class="sr-only">
                    <span class="filter-label">Composition</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoAdd.compos">{{facets.typoAdd.compos}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoAdd.includes('trans') }">
                    <input type="checkbox" id="trans" value="trans" v-model="typoAdd" class="sr-only">
                    <span class="filter-label">Transformation</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoAdd.trans">{{facets.typoAdd.trans}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoAdd.includes('compar') }">
                    <input type="checkbox" id="compar" value="compar" v-model="typoAdd" class="sr-only">
                    <span class="filter-label">Comparaison</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoAdd.compar">{{facets.typoAdd.compar}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoAdd.includes('compos-de-trans') }">
                    <input type="checkbox" id="compos-de-trans" value="compos-de-trans" v-model="typoAdd" class="sr-only">
                    <span class="filter-label">Composition de transformations</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoAdd['compos-de-trans']">{{facets.typoAdd['compos-de-trans']}}</b-badge>
                  </label>
                </div>
              </div>

              <!-- Typologies Multiplicatif - Sous-menu -->
              <div v-show="categories.includes('MUL') && categories.length == 1" class="filter-submenu">
                <h4 class="filter-subtitle">
                  <i class="bi bi-x-circle me-2"></i>Typologie Multiplicatif
                </h4>
                <div class="filter-options">
                  <label class="filter-option filter-option-submenu" :class="{ active: typoMul.includes('n-times') }">
                    <input type="checkbox" id="n-times" value="n-times" v-model="typoMul" class="sr-only">
                    <span class="filter-label">n fois plus ou n fois moins</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoMul['n-times']">{{facets.typoMul['n-times']}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoMul.includes('rect') }">
                    <input type="checkbox" id="rect" value="rect" v-model="typoMul" class="sr-only">
                    <span class="filter-label">Rectangulaire</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoMul.rect">{{facets.typoMul.rect}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoMul.includes('cartesian') }">
                    <input type="checkbox" id="cartesian" value="cartesian" v-model="typoMul" class="sr-only">
                    <span class="filter-label">Produit cartésien</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoMul.cartesian">{{facets.typoMul.cartesian}}</b-badge>
                  </label>
                </div>
              </div>

              <!-- Typologies Division - Sous-menu -->
              <div v-show="categories.includes('DIV') && categories.length == 1" class="filter-submenu">
                <h4 class="filter-subtitle">
                  <i class="bi bi-slash-circle me-2"></i>Typologie Division
                </h4>
                <div class="filter-options">
                  <label class="filter-option filter-option-submenu" :class="{ active: typoDiv.includes('partition') }">
                    <input type="checkbox" id="partition" value="partition" v-model="typoDiv" class="sr-only">
                    <span class="filter-label">Partition</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoDiv.partition">{{facets.typoDiv.partition}}</b-badge>
                  </label>
                  <label class="filter-option filter-option-submenu" :class="{ active: typoDiv.includes('quotition') }">
                    <input type="checkbox" id="quotition" value="quotition" v-model="typoDiv" class="sr-only">
                    <span class="filter-label">Quotition</span>
                    <b-badge pill class="filter-badge" v-if="facets.typoDiv.quotition">{{facets.typoDiv.quotition}}</b-badge>
                  </label>
                </div>
              </div>
            </div>

            <!-- Domaine -->
            <div class="filter-card filter-card-success">
              <h3 class="filter-title">
                <i class="bi bi-diagram-3 me-2"></i>Domaine
              </h3>
              <div class="filter-options">
                <label class="filter-option" :class="{ active: domains.includes('INT') }">
                  <input type="checkbox" id="int" value="INT" v-model="domains" class="sr-only">
                  <span class="filter-label">Entiers</span>
                  <b-badge pill class="filter-badge" v-if="facets.domain.INT">{{facets.domain.INT}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: domains.includes('DEC') }">
                  <input type="checkbox" id="dec" value="DEC" v-model="domains" class="sr-only">
                  <span class="filter-label">Décimaux</span>
                  <b-badge pill class="filter-badge" v-if="facets.domain.DEC">{{facets.domain.DEC}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: domains.includes('FRAC') }">
                  <input type="checkbox" id="frac" value="FRAC" v-model="domains" class="sr-only">
                  <span class="filter-label">Fractions</span>
                  <b-badge pill class="filter-badge" v-if="facets.domain.FRAC">{{facets.domain.FRAC}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: domains.includes('GEO') }">
                  <input type="checkbox" id="geo" value="GEO" v-model="domains" class="sr-only">
                  <span class="filter-label">Géométrie</span>
                  <b-badge pill class="filter-badge" v-if="facets.domain.GEO">{{facets.domain.GEO}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: domains.includes('LOGOS') }">
                  <input type="checkbox" id="logos" value="LOGOS" v-model="domains" class="sr-only">
                  <span class="filter-label">Logique</span>
                  <b-badge pill class="filter-badge" v-if="facets.domain.LOGOS">{{facets.domain.LOGOS}}</b-badge>
                  </label>
              </div>
            </div>

            <!-- Complexité -->
            <div class="filter-card filter-card-danger">
              <h3 class="filter-title">
                <i class="bi bi-graph-up me-2"></i>Complexité
              </h3>
              <div class="filter-options">
                <label class="filter-option" :class="{ active: complexities.includes('one') }">
                  <input type="checkbox" id="one" value="one" v-model="complexities" class="sr-only">
                  <span class="filter-label">Une étape</span>
                  <b-badge pill class="filter-badge" v-if="facets.complexity.one">{{facets.complexity.one}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: complexities.includes('more') }">
                  <input type="checkbox" id="more" value="more" v-model="complexities" class="sr-only">
                  <span class="filter-label">Plus d'une étape</span>
                  <b-badge pill class="filter-badge" v-if="facets.complexity.more">{{facets.complexity.more}}</b-badge>
                  </label>
                <label class="filter-option" :class="{ active: complexities.includes('atypique') }">
                  <input type="checkbox" id="atypique" value="atypique" v-model="complexities" class="sr-only">
                  <span class="filter-label">Atypique</span>
                  <b-badge pill class="filter-badge" v-if="facets.complexity.atypique">{{facets.complexity.atypique}}</b-badge>
                  </label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'SearchItem',
  props: {
    facets: Object
  },
  data() {
    return {
      levels: [],
      categories: [],
      domains: [],
      complexities: [],
      typoAdd: [],
      typoMul: [],
      typoDiv: [],
      isExpanded: false,
      showHeartbeat: true
    } 
  },
  mounted() {
    // Arrêter l'animation heartbeat après 10 secondes
    setTimeout(() => {
      this.showHeartbeat = false
    }, 10000)
    
    const collapseElement = document.getElementById('filterCollapse');
    if (collapseElement) {
      collapseElement.addEventListener('shown.bs.collapse', () => {
        this.isExpanded = true;
      });
      collapseElement.addEventListener('hidden.bs.collapse', () => {
        this.isExpanded = false;
      });
    }
  },
  methods: {
    toggleExpanded() {
      // L'état sera géré par les événements Bootstrap collapse
    } 
  },
  computed: {
    filters() {
      let levelsFilter = computeOR(this.levels, 'level')
      let categoriesFilter = computeOR(this.categories, 'category')
      let domainsFilter = computeOR(this.domains, 'domain')
      let complexitiesFilter = computeOR(this.complexities, 'complexity')      
      let filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter])
      if(this.categories == 'ADD') {
        let typoAddFilter = computeOR(this.typoAdd, 'typoAdd')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoAddFilter])
      }
      if(this.categories == 'MUL') {
        let typoMulFilter = computeOR(this.typoMul, 'typoMul')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoMulFilter])
      }
      if(this.categories == 'DIV') {
        let typoDivFilter = computeOR(this.typoDiv, 'typoDiv')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoDivFilter])
      }
      return filters
    }
  },
  watch: { filters() { this.$emit('refresh', this.filters) } }
}

let computeOR = function(array, name) {
  if(array.length > 0) {
    let filter = array.map(item => `${name}:${item} OR`).join(' ').slice(0, -3)
    return `(${filter})`
  } else {
    return null
  }
}

let computeAND = function(array) {
  let filters = array.map(item => item ? `${item} AND`: null).join(' ')
  filters = filters.trim()
  let l = filters.length
  let endFilters = filters.substring(l - 4, l)
  if(endFilters == ' AND') { filters = filters.slice(0, -4) }
  return filters
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-section {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.filter-toggle-btn {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-toggle-btn.heartbeat-active {
  animation: heartbeat 2s ease-in-out 0.5s 4;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  20% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.1);
  }
  40% {
    transform: scale(1);
  }
}

.filter-toggle-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.filter-toggle-btn i {
  margin-left: 0.5rem;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1;
}

.filter-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.filter-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid;
}

.filter-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.filter-card-warning {
  border-left-color: #ffc107;
}

.filter-card-info {
  border-left-color: #0dcaf0;
}

.filter-card-success {
  border-left-color: #198754;
}

.filter-card-danger {
  border-left-color: #dc3545;
}

.filter-card-typo {
  border-left-color: #198754;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
}

.filter-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-title i {
  margin-right: 0.5rem;
  font-size: 0.95rem;
}

.typo-title {
  color: #198754;
}

.filter-submenu {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 2px solid #e9ecef;
  padding-left: 1rem;
  border-left: 3px solid #198754;
  margin-left: 0.5rem;
}

.filter-subtitle {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.6rem;
  color: #198754;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.filter-subtitle i {
  margin-right: 0.4rem;
  font-size: 0.85rem;
}

.filter-option-submenu {
  font-size: 0.85rem;
  padding: 0.4rem 0.875rem;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.filter-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  font-size: 0.9rem;
}

.filter-option:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: scale(1.05);
}

.filter-option.active {
  background: #198754;
  border-color: #198754;
  color: white;
  font-weight: 500;
}

.filter-option.active .filter-label {
  color: white;
}

.filter-label {
  color: #495057;
  transition: color 0.2s ease;
}

.filter-option.active .filter-label {
  color: white;
}

.filter-badge {
  background-color: rgba(108, 117, 125, 0.2);
  color: #495057;
  font-size: 0.65rem;
  padding: 0.15rem 0.4rem;
  margin-left: 0.25rem;
  transition: all 0.2s ease;
  line-height: 1.2;
}

.filter-option.active .filter-badge {
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .filter-container {
    gap: 0.6rem;
  }

  .filter-card {
    padding: 0.875rem;
  }

  .filter-title {
    font-size: 0.95rem;
    margin-bottom: 0.6rem;
  }

  .filter-options {
    gap: 0.4rem;
  }

  .filter-option {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }

  .filter-submenu {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    padding-left: 0.75rem;
    margin-left: 0.25rem;
  }

  .filter-subtitle {
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
  }

  .filter-option-submenu {
    font-size: 0.85rem;
    padding: 0.35rem 0.75rem;
  }
}

@media (max-width: 576px) {
  .search-section {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .filter-container {
    gap: 0.5rem;
    margin-top: 1rem;
  }

  .filter-card {
    padding: 0.75rem;
  }

  .filter-title {
    font-size: 0.9rem;
    margin-bottom: 0.6rem;
  }

  .filter-options {
    gap: 0.35rem;
  }

  .filter-option {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
    flex: 1 1 calc(50% - 0.35rem);
    min-width: calc(50% - 0.35rem);
    justify-content: center;
  }

  .filter-submenu {
    margin-top: 0.6rem;
    padding-top: 0.6rem;
    padding-left: 0.6rem;
    margin-left: 0.2rem;
  }

  .filter-subtitle {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }

  .filter-option-submenu {
    font-size: 0.75rem;
    padding: 0.3rem 0.65rem;
  }

  .filter-badge {
    font-size: 0.6rem;
    padding: 0.1rem 0.3rem;
    line-height: 1.1;
  }
}

/* Animation pour le collapse */
.collapse {
  transition: height 0.35s ease;
}

/* Icon Bootstrap Icons fallback */
.bi {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}

/* Fix pour les anciens styles */
    .problem-number-div {
      margin-top: 16px;
    }
</style>